<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-25 10:25:38
 * @ Modified by: Your name
 * @ Modified time: 2019-07-01 10:57:34
 * @ Description: 柜门管理
 -->

<template>
  <div class="content-wrapper">
    <el-form label-width="100px" label-position="right" ref="searchForm"
      :model="formData.data" class="search-form" :inline="true">
      <div class="search-row">
        <el-form-item label="柜门状态" prop="cabinetDoorStatus">
          <el-select v-model="formData.data.cabinetDoorStatus"
            clearable placeholder="请选择" size="small">
            <el-option value="" label="全部"></el-option>
            <el-option
              v-for="item in cabinetDoorStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" size="small" :loading="loadingSearch"
            icon="el-icon-search" class="search-btn" @click="searchTableData">查询</el-button>
        <el-button type="warning" size="small" @click="handleBack()"
          icon="el-icon-refresh-left" v-if='hopRouting'>返回设备管理</el-button>
        <el-button type="success" size="small" @click="changeState()"
          icon="el-icon-refresh-left" v-if='hopRouting'>变更柜门状态</el-button>
      </div>
    </el-form>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :isCheckbox='true'
      :height='500'
      :loading='tableLoading'
      service
      @service-fn="handleService"
      @row-click="rowClick"
      @selection-change="selectionChange">
      <el-table-column
        :selectable='isDisabled'
        type="selection"
        width="40">
      </el-table-column>
      <el-table-column prop="cabinetNumber" label="柜子编号" align="center" sortable/>
      <el-table-column prop="cabinetName" label="柜子名字" align="center"/>
      <el-table-column prop="cabinetDoorNumber" label="柜门编号" align="center"/>
      <el-table-column prop="cabinetDoorName" label="柜门号" align="center"/>
      <el-table-column prop="lockPlateNumber" label="锁板编号" align="center"/>
      <el-table-column prop="lockNumber" label="锁编号" align="center" />
      <el-table-column prop="cabinetDoorSize" label="柜门尺寸" align="center" width="110">
        <template slot-scope="scope">
          {{formatColumn(scope.column.property, scope.row.cabinetDoorSize)}}
        </template>
      </el-table-column>
      <el-table-column prop="cabinetDoorStatus" label="柜门状态" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          {{formatColumn(scope.column.property, scope.row.cabinetDoorStatus)}}
        </template>
      </el-table-column>
    </table-pagination>
    <el-dialog
      title="变更柜门状态"
      :visible.sync="changeDialogVisible"
      width="20%"
      :before-close="handleClose"
      >
      <div class="cabinet-door-state">
        <el-radio v-model="cabinetDoorState" label="0">正常</el-radio>
        <el-radio v-model="cabinetDoorState" label="3">柜门故障</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small" type="info">取 消</el-button>
        <el-button size="small" type="primary" @click="sureChange">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tables from '../../mixins/table'
import { DOOR_MANAGE } from '../../libs/api'

export default {
  name: 'doorManage',
  mixins: [tables],
  data() {
    return {
      hopRouting: this.$route.query.path, // 判断是否是由设备管理跳转过来的
      formLoading: false, // 表单加载遮罩
      formInited: true, // 表单是否已完成初始化
      loadingSearch: false, // 查询按钮禁用
      tableLoading: false,
      formData: {
        pageNum: 1,
        pageSize: 10,
        orderBy: '',
        data: {
          cabinetDoorStatus: '', // 柜门状态
          deviceNumber: this.$route.query.deviceNumber // 设备管理页面 跳转过来的 deviceNumber
        }
      },
      cabinetDoorStatusList: [{
        label: '有退料',
        value: 2
      }, {
        label: '柜门故障',
        value: 3
      }, {
        label: '有航材',
        value: 1
      }, {
        label: '无航材',
        value: 0
      }],
      dic: { // 字典格式化
        cabinetDoorSize: {
          3: '超大',
          2: '大',
          1: '中',
          0: '小'
        },
        cabinetDoorStatus: {
          3: '柜门故障',
          2: '有退料',
          1: '有航材',
          0: '无航材'
        }
      },
      searchUrl: DOOR_MANAGE.GET_LIST,
      updateStateUrl: DOOR_MANAGE.UPDATESTATE,
      changeDialogVisible: false,
      cabinetDoorState: '0', // 变更柜门状态 0 正常 3 柜门故障
      selection: [], // 当前多选框选中项
    }
  },
  mounted() {
    // table 数据表查询
    this.searchTableData()
  },
  methods: {
    formatColumn(cellName, cellValue) {
      return this.dic[cellName][cellValue]
    },
    handleBack() { // 返回上一个跳转过来的页面
      this.$router.push({ path: `${this.hopRouting}` })
    },
    searchTableData() {
      this.handleSearch(this.searchUrl, this.formData)
    },
    changeState() {
      if (this.selection.length == 0) {
        this.$notify.warning({
          title: '错误',
          message: '请至少选择一条柜门数据'
        })
      } else {
        this.cabinetDoorState = '0'
        this.changeDialogVisible = true
      }
    },
    handleClose() {
      this.changeDialogVisible = false
    },
    sureChange() {
      const query = {
        cabinetDoorStatus: this.cabinetDoorState,
        cabinetDoorIds: [],
        updateBy: sessionStorage.getItem('userName'),
        updateDate: new Date().getTime()
      }
      this.selection.forEach(item => {
        query.cabinetDoorIds.push(item.id)
      })
      this.$http.post(this.updateStateUrl, query).then(res => {
        if (res.data.code === 1) {
          this.$notify.success({
            title: '操作成功',
            message: '变更柜门状态成功'
          })
          this.searchTableData()
        }
      }).catch(err => {
        this.$notify.error({
          title: '错误',
          message: '数据修改失败'
        })
      })
      this.changeDialogVisible = false
    },
    isDisabled(row) {
      if (row.cabinetDoorStatus == '0' || row.cabinetDoorStatus == '3') {
        row.isDisabled = false
        return 1
      }
      row.isDisabled = true
      return 0
    },
    rowClick(row) { // 重新该方法，处理禁用状态的行能够被勾选
      if (row.isDisabled) {
        return
      }
      this.$refs.table.toggleRowSelection(row)
    },
    // 多选框选中项
    selectionChange(selection) {
      this.selection = selection;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper{
  .search-row{
    height: 46px;
    .el-button{
      margin-top: 5px;
    }
  }
}

.cabinet-door-state{
  width: 30%;
  height: 44px;
  margin: 0 auto;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
